import React, {Component} from 'react';
import {Card, Table} from "antd";
import {Controls} from "./Controls";
import {ProjectSelector} from "./ProjectSelector";
import * as PropTypes from "prop-types";

const default_columns = [
  {
    title: 'Overview',
    dataIndex: 'overview',
    sorter: (a, b) => a.overview - b.overview,
    render: (text) => <span className='formatted-text'>{text}</span>
  },
  {
    title: 'Users',
    dataIndex: 'users',
    sorter: (a, b) => a.users - b.users,
    width: 200,
    render: (text) => <span className='formatted-text'>{text}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: (a, b) => a.status.toLocaleLowerCase().localeCompare(b.status.toLocaleLowerCase()),
    width: 100,
    render: (text) => <span className='formatted-text'>{text}</span>
  }
];

export default class DetailsView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { projectname: this.props.projects ? '-AllProjects' : '' }
  }

  componentDidMount = () => this.props.onMount && this.props.onMount();

  handleChange = id => {
    const projectname = this.props.projects ? id ? `-Project-${this.props.projects.find(e => e.id === id).name}` : '-AllProjects' : '';
    this.setState({ projectname });
    return this.props.updateFilters(id);
  };

  render() {
    const { report: { resource: report } = {}, name, columns, projects, pdfGenerator } = this.props;
    if (!report) return null;

    return <Card
      title={<h1>{name}</h1>}
      extra={[<Controls pdfGenerator={() => pdfGenerator(name + this.state.projectname)}/>]}
    >
      <ProjectSelector projects={projects} onSelect={this.handleChange}/>
      <Table id='listElement' pagination={false} columns={columns || default_columns} dataSource={report}/>
    </Card>;
  }
}

DetailsView.propTypes = {
  report: PropTypes.object,
  name: PropTypes.string,
  columns: PropTypes.object,
  projects: PropTypes.object,
  onMount: PropTypes.func,
  updateFilters: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Reports/DetailsView.js